import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { filledIcon, formatRatingValue, iconFill, isCustomRatingIcon, parseLevels, ratingMax } from '@/util/ratings'
import { tagChipStyle } from '@/util/tagChip'

// Read-only rating: icons with half fill, or a named level. `scale` is a rating scale or a shaped
// rating from the API (both carry display_type, max_value, levels, icon, color); `icon` and
// `color` override the scale's for one event.

const __default__ = { name: 'rating-display' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: { type: Number, default: null },
  scale: { type: Object, required: true },
  icon: { type: String, default: null },
  color: { type: String, default: null },
  size: { type: String, default: 'md' }, // xs | sm | md | lg
},
  setup(__props) {

const props = __props



const isLabels = computed(() => props.scale.display_type === 'labels')
const max = computed(() => ratingMax(props.scale as any))
const effectiveIcon = computed(() => props.icon || props.scale.icon || 'star')
const effectiveColor = computed(() => props.color || props.scale.color || '#e14eca')
const custom = computed(() => isCustomRatingIcon(effectiveIcon.value))
const filledIconName = computed(() => filledIcon(effectiveIcon.value))
const levelName = computed(() => parseLevels(props.scale.levels)[Number(props.value) - 1] || '')
const ariaLabel = computed(() => props.value == null ? 'Not rated' : formatRatingValue(props.value, props.scale as any))

function fill(n: number) {
  return iconFill(props.value, n)
}

return { __sfc: true,props, isLabels, max, effectiveIcon, effectiveColor, custom, filledIconName, levelName, ariaLabel, fill, tagChipStyle }
}

})